import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import DaProtectNotice from '../DaProtectNotice';
import BetaBadge from '../../../BetaBadge';
import s from './HoverComponent.scss';
var type2image = {
    da_muro: 'il35_-_muro_v3.svg',
    poll: 'il33_-_poll_v3.svg',
    status: 'il30_-_status_update_v3.svg',
    deviation: 'il29_-_deviation_v3.svg',
    journal: 'il31_-_journal_v3.svg',
    literature: 'il32_-_literature_v3.svg',
    commission: 'il62_-_commission_v3.svg',
    tier: 'il6_9_-_tip_jar.svg', // IL6.9
};
var HoverComponent = function (_a) {
    var svg = _a.svg, title = _a.title, context = _a.context, className = _a.className, _b = _a.isNew, isNew = _b === void 0 ? false : _b, _c = _a.showDaProtect, showDaProtect = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: classnames(s['container'], showDaProtect && s['da-protect-container'], isNew && s['new-container']) },
            React.createElement("div", { className: s['svg'] },
                React.createElement("img", { loading: "lazy", src: Url.staticCDNLink("eclipse/popups/hover-component/" + type2image[svg]), alt: svg })),
            isNew && (React.createElement(BetaBadge, { badgeType: "new", variant: "medium" })),
            React.createElement("div", { className: s['title'] }, title),
            React.createElement("div", { className: s['context'] }, context),
            showDaProtect && React.createElement(DaProtectNotice, null))));
};
HoverComponent.displayName = 'HoverComponent';
export default HoverComponent;
//# sourceMappingURL=HoverComponent.js.map